import { render } from "./AdminGaps.vue?vue&type=template&id=70c5bf2d"
import script from "./AdminGaps.vue?vue&type=script&lang=js"
export * from "./AdminGaps.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__